export default "__VITE_ASSET__tV6vjXy___"